<template>
  <v-select
    class="managed-by-select py-0"
    :value="value"
    :items="items"
    :placeholder="$t('placeholder')"
    hide-details
    data-testid="managed-by-select"
    @change="selected => $emit('input', selected)"
  />
</template>

<i18n lang="yaml">
ja:
  placeholder: '管理元'
  all: 'すべて'
  distributors: '代理店'

en:
  placeholder: 'Managed by'
  all: 'All'
  distributors: 'Distributors'
</i18n>

<script>
import { directLabel, toManagedBySelectItems } from '@/libs/managedBy';

export default {
  name: 'managed-by-select',
  props: {
    // 未選択は null。'all' / 'direct' / 代理店の id のいずれか
    value: {
      type: String,
      default: null,
    },
    // extractDistributors の戻り値
    distributors: {
      type: Array,
      required: true,
    },
  },
  computed: {
    items() {
      return toManagedBySelectItems(this.distributors, {
        all: this.$t('all'),
        direct: directLabel(this.$i18n.locale),
        distributors: this.$t('distributors'),
      });
    },
  },
};
</script>

<style scoped lang="sass">
.managed-by-select
  // 隣の検索欄（32px）と高さを揃える。中身の高さは未選択 28px / 選択中 32px と変わるため、padding ではなく高さで揃える
  ::v-deep .v-input__slot
    height: 32px
    padding-left: 8px

    // main.sass が全 v-select の下線を消しているため、検索欄と同じ下線を戻す
    &::before,
    &::after
      display: block

  ::v-deep .v-select__selection
    margin-top: 0
    margin-bottom: 0
</style>
